// MIT License - Copyright (c) 2026 Doug McNall - See .kiro/steering/general/development-standards.md for full license

import React, { lazy, Suspense } from 'react';
import { createPortal } from 'react-dom';
import { useAuth } from '../contexts/AuthContext';
import './DeveloperToolsModal.css';

// Lazy-load DeveloperTools — admin-only tool, ~706 LOC plus all dev-tool sub-components.
// Excluded from initial bundle since most users will never open it.
const DeveloperTools = lazy(() => import('../pages/DeveloperTools'));

function DeveloperToolsModal({ show, onClose }) {
  const { isAdmin, loading } = useAuth();

  if (!show) return null;

  // Admin check
  if (loading) {
    return createPortal(
      <div className="dev-tools-modal-overlay">
        <div className="dev-tools-loading">Loading...</div>
      </div>,
      document.body
    );
  }

  if (!isAdmin) {
    return createPortal(
      <div className="dev-tools-modal-overlay" onClick={onClose}>
        <div className="dev-tools-access-denied" onClick={e => e.stopPropagation()}>
          <h2>Access Denied</h2>
          <p>Admin privileges required</p>
          <button onClick={onClose} className="close-button">Close</button>
        </div>
      </div>,
      document.body
    );
  }

  return createPortal(
    <div className="dev-tools-modal-overlay">
      <div className="dev-tools-modal-container">
        <button 
          className="dev-tools-close-button" 
          onClick={onClose}
          title="Close Developer Tools"
        >
          ✕
        </button>
        <Suspense fallback={<div className="dev-tools-loading">Loading developer tools…</div>}>
          <DeveloperTools />
        </Suspense>
      </div>
    </div>,
    document.body
  );
}

export default DeveloperToolsModal;
